/*
 *
 * CollaboratorsImport actions
 *
 */

import {
  GET_TEMPLATE_COLLABORATORS_WATCHER,
  GET_TEMPLATE_COLLABORATORS_SUCCESS,
  GET_TEMPLATE_COLLABORATORS_FAILED,
  UPLOAD_TEMPLATE_COLLABORATORS_WATCHER,
  UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS,
  UPLOAD_TEMPLATE_COLLABORATORS_FAILED,
  GET_TEMPLATE_CEASED_WATCHER,
  GET_TEMPLATE_CEASED_SUCCESS,
  GET_TEMPLATE_CEASED_FAILED,
  UPLOAD_TEMPLATE_CEASED_WATCHER,
  UPLOAD_TEMPLATE_CEASED_SUCCESS,
  UPLOAD_TEMPLATE_CEASED_FAILED,
  GET_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER,
  GET_TEMPLATE_DIVISIONS_ASSIGNMENT_SUCCESS,
  GET_TEMPLATE_DIVISIONS_ASSIGNMENT_FAILED,
  UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER,
  UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_SUCCESS,
  UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_FAILED,
  GET_TEMPLATE_TEAMS_WATCHER,
  GET_TEMPLATE_TEAMS_SUCCESS,
  GET_TEMPLATE_TEAMS_FAILED,
  UPLOAD_TEMPLATE_TEAMS_SUCCESS,
  UPLOAD_TEMPLATE_TEAMS_FAILED,
  UPLOAD_TEMPLATE_TEAMS_WATCHER
} from "./constants"

// UPLOAD EXCEL CEASEd
export function uploadTemplateCeasedWatcher(payload) {
  return {
    type: UPLOAD_TEMPLATE_CEASED_WATCHER,
    payload,
  }
}

export function uploadTemplateCeasedSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_CEASED_SUCCESS,
    payload,
  }
}

export function uploadTemplateCeasedFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_CEASED_FAILED,
    payload,
  }
}


// UPLOAD EXCEL DIVISIONS ASSIGNMENT
export function uploadTemplateDivisionsAssignmentWatcher(payload) {
  return {
    type: UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER,
    payload
  }
}
// UPLOAD EXCEL TEAMS
export function uploadTemplateTeamsWatcher(payload) {
  return {
    type: UPLOAD_TEMPLATE_TEAMS_WATCHER,
    payload,
  }
}

export function uploadTemplateDivisionsAssignmentSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_SUCCESS,
    payload
  }
}
export function uploadTemplateTeamsSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_TEAMS_SUCCESS,
    payload,
  }
}

export function uploadTemplateDivisionsAssignmentFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_FAILED,
    payload
  }
}

export function uploadTemplateTeamsFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_TEAMS_FAILED,
    payload,
  }
}


// GET TEMPLATE CEASED
export function getTemplateCeasedWatcher(payload) {
  return {
    type: GET_TEMPLATE_CEASED_WATCHER,
    payload,
  }
}

export function getTemplateCeasedSuccess(payload) {
  return {
    type: GET_TEMPLATE_CEASED_SUCCESS,
    payload,
  }
}

export function getTemplateCeasedFailed(payload) {
  return {
    type: GET_TEMPLATE_CEASED_FAILED,
    payload,
  }
}


// GET TEMPLATE DIVISIONS ASSIGNMENT


export function getTemplateDivisionsAssignmentWatcher(payload) {
  return {
    type: GET_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER,
    payload
  }
}

// GET TEMPLATE TEAMS
export function getTemplateTeamsWatcher(payload) {
  return {
    type: GET_TEMPLATE_TEAMS_WATCHER,
    payload,
  }
}

export const getTemplateDivisionsAssignmentSuccess = (payload) => ({
  type: GET_TEMPLATE_DIVISIONS_ASSIGNMENT_SUCCESS,
  payload,
})

export const getTemplateDivisionsAssignmentFailed = (payload) => ({
  type: GET_TEMPLATE_DIVISIONS_ASSIGNMENT_FAILED,
  payload,
})

export function getTemplateTeamsSuccess(payload) {
  return {
    type: GET_TEMPLATE_TEAMS_SUCCESS,
    payload,
  }
}

export function getTemplateTeamsFailed(payload) {
  return {
    type: GET_TEMPLATE_TEAMS_FAILED,
    payload,
  }
}

// GET EXCEL
export function getTemplateCollaboratorsWatcher(payload) {
  return {
    type: GET_TEMPLATE_COLLABORATORS_WATCHER,
    payload,
  }
}

export function getTemplateCollaboratorsSuccess(payload) {
  return {
    type: GET_TEMPLATE_COLLABORATORS_SUCCESS,
    payload,
  }
}

export function getTemplateCollaboratorsFailed(payload) {
  return {
    type: GET_TEMPLATE_COLLABORATORS_FAILED,
    payload,
  }
}

// UPLOAD EXCEL
export function uploadTemplateCollaboratorsWatcher(payload) {
  return {
    type: UPLOAD_TEMPLATE_COLLABORATORS_WATCHER,
    payload,
  }
}

export function uploadTemplateCollaboratorsSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_COLLABORATORS_SUCCESS,
    payload,
  }
}

export function uploadTemplateCollaboratorsFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_COLLABORATORS_FAILED,
    payload,
  }
}
